export var REACT_RENDER_OP = 'ui.react.render';
export var REACT_UPDATE_OP = 'ui.react.update';
export var REACT_MOUNT_OP = 'ui.react.mount';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/react/esm/constants.js
// module id = 4601
// module chunks = 7